const tecno = [
    { T: 'Unity', L: 'https://unity.com/es' },
    { T: 'C#', L: 'https://docs.microsoft.com/en-us/dotnet/csharp/' },
    { T: 'Wordpress', L: 'https://wordpress.org/' },
    { T: 'HTML', L: 'https://www.w3schools.com/html/' },
    { T: 'CSS', L: 'https://www.w3schools.com/css/' },
    { T: 'React', L: 'https://es.reactjs.org/' },
    { T: 'Bootstrap', L: 'https://getbootstrap.com/' },
    { T: 'Python', L: 'https://www.python.org/' },
    { T: 'MySql', L: 'https://www.mysql.com/' },
    { T: 'Qlik Sense', L: 'https://www.qlik.com/es-es/products/qlik-sense' },
    { T: 'Pentaho', L: 'https://www.hitachivantara.com/en-us/products/data-management-analytics/pentaho.html' },
    { T: 'Oracle', L: 'https://www.oracle.com/index.html' },
    { T: 'Java', L: 'https://www.oracle.com/java/technologies/downloads/' },
    { T: 'Materialize', L: 'https://materializecss.com/' },
    { T: 'Three.js', L: 'https://threejs.org/' },
    { T: 'Sass', L: 'https://sass-lang.com/' },
    { T: 'Gsap', L: 'https://greensock.com/' },
    { T: 'Sticker.js', L: 'http://stickerjs.cmiscm.com/' },
    { T: 'Particles.js', L: 'https://vincentgarreau.com/particles.js/' },
    { T: 'Sweetalert.js', L: 'https://sweetalert.js.org/' },
    { T: 'Sweetalert2', L: 'https://sweetalert2.github.io/' },
    { T: 'JavaScript', L: 'https://www.w3schools.com/js/default.asp' },
    { T: 'Blender', L: 'https://www.blender.org/' },
    
];

export default tecno;